import type { IxfWatchlistV1Fincen314EntryKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const FINCEN_ENTRY_BASE_PATH = getResolvedPath('/clearing/compliance/fincen/entry');

export const getFincenEntryPath: EntityPathBuilder<IxfWatchlistV1Fincen314EntryKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FINCEN_ENTRY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.fincen314EntryId) {
        return undefined;
      }

      return getResolvedPath(`${FINCEN_ENTRY_BASE_PATH}/$fincen314EntryId`, context.keys);
    }
  }
};

export function getFincenEntryDetailPath(fincen314EntryId: string | undefined) {
  if (!fincen314EntryId) {
    return undefined;
  }

  return getFincenEntryPath({ kind: 'detail', keys: { fincen314EntryId } });
}
